import React from "react";
import moment from "moment";
import "../App.css";

const OperationTable = ({
  operations,
  handleClick,
  handleDelete,
  user,
  itemsCount,
}) => {
  return (
    <table className="table table-hover">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {itemsCount} Operations
      </caption>
      <thead>
        <tr>
          <th>Code</th>
          <th>Type</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Last Updated</th>
          <th>Updated By</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {operations.map((operation) => (
          <tr key={operation.OPTN_CODE}>
            <td>
              {moment.utc().diff(operation.END_DATE) < 0 &&
              user.SITE !== "CO" ? (
                <button
                  className="btn btn-link btn-left-align"
                  onClick={() => handleClick("Update", operation)}
                >
                  {operation.OPTN_CODE}
                </button>
              ) : (
                operation.OPTN_CODE
              )}
            </td>
            <td>{operation.COMMENTS}</td>
            <td>{moment.utc(operation.START_DATE).format("DD-MMM-YY")}</td>
            <td>{moment.utc(operation.END_DATE).format("DD-MMM-YY")}</td>
            <td>{moment.utc(operation.LAST_UPDATED_DTS).fromNow()}</td>
            <td>{operation.LAST_UPDATED_BY}</td>
            <td>
              {/* Need to Consider Future Operations - PENDING status */}
              {moment.utc().diff(operation.END_DATE) < 0 ? (
                moment.utc().diff(operation.START_DATE) < 0 ? (
                  <span className="badge badge-primary">Pending</span>
                ) : (
                  <span className="badge badge-success">Active</span>
                )
              ) : (
                <span className="badge badge-warning">Finished</span>
              )}
            </td>
            {moment.utc().diff(operation.START_DATE) < 0 ? (
              <td>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(operation)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </td>
            ) : (
              <td />
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OperationTable;
